export const mouseConstants = {
    MOVE: 'MOUSE_MOVE',
};
